import { httpsCallable } from 'firebase/functions';
import { functions } from '../firebaseConfig';

/**
 * The workspace's own AI key. Verified and stored server-side; the key itself
 * never comes back to the browser — only whether one is configured, the last
 * four characters, and whether it still works.
 */
export async function setWorkspaceAiKey(workspaceId, apiKey) {
  const res = await httpsCallable(functions, 'setWorkspaceAiKey')({ workspaceId, apiKey });
  return res?.data || { success: false, error: 'No response.' };
}

export async function getWorkspaceAiKeyStatus(workspaceId) {
  try {
    const res = await httpsCallable(functions, 'getWorkspaceAiKeyStatus')({ workspaceId });
    return res?.data || { configured: false };
  } catch {
    return { configured: false };
  }
}

export async function removeWorkspaceAiKey(workspaceId) {
  const res = await httpsCallable(functions, 'removeWorkspaceAiKeyFn')({ workspaceId });
  return res?.data || { success: false };
}
